import { environment } from "@env/environment";
const overridableRegistry = new Map<any, string[]>();
export function EmptyOverridable(): MethodDecorator {
  return (target, propertyKey) => {
    const classPrototype = target as any; // target is the prototype, not the instance
    if (!overridableRegistry.has(classPrototype)) {
      overridableRegistry.set(classPrototype, []);
    }
    overridableRegistry.get(classPrototype)?.push(propertyKey.toString());
  };
}

export function validateOverridables(instance, className, baseClass) {
  if (environment.production) {
    return;
  }
  const hooks = overridableRegistry.get(baseClass.prototype);
  const missingHooks = hooks.filter(
    (hook) => {
      return instance[hook] === baseClass.prototype[hook]; // Check if still using base implementation
    }
  );

  if (missingHooks.length > 0) {
    console.warn(`🚨 [${className}] Consider overriding method(s): ${missingHooks.join(', ')}`);
  }
}